<template>
  <section>
    <div class="grid grid-cols-1 px-3 py-12 max-w-7xl mx-auto font-open-sans">
      <div class="quote py-6 px-8 md:py-6 md:px-12 lg:py-8 lg:px-20 text-black bg-lifeboost-red-lighter relative">
        <blockquote class="textp">
          <p class="m-0 p-0" v-html=" quoteData.text"></p>
          <span class="float-right block pt-2" v-html="quoteData.author"></span>
        </blockquote>
      </div>
    </div>
  </section>
</template>

<script setup>
const props = defineProps({
  quoteData: {
    type: Object,
    default: () => ({
      text: '“The coffee is amazing. I had stopped drinking coffee because of certain side effects I was feeling after drinking it. This coffee didn\'t seem to create any of those problems for me. The flavor is amazing and the coloring - WOW.”',
      author: '- S. Vagivagi'
    })
  }
});

defineBuilderComponent({
    friendlyName: "Info",
    canHaveChildren: false,
    inputs: [
        {
            name: "quoteData",
            type: "object",
            subFields: [
                {
                    name: "text",
                    type: "richText",
                    defaultValue: "“The coffee is amazing. I had stopped drinking coffee because of certain side effects I was feeling after drinking it. This coffee didn't seem to create any of those problems for me. The flavor is amazing and the coloring - WOW.”"
                },
                {
                    name: "author",
                    type: "string",
                    defaultValue: "- S. Vagivagi"
                }
            ],
            defaultValue: {
                text: "“The coffee is amazing. I had stopped drinking coffee because of certain side effects I was feeling after drinking it. This coffee didn't seem to create any of those problems for me. The flavor is amazing and the coloring - WOW.”",
                author: "- S. Vagivagi"
            }
        }
    ]
});
</script>

<style>
.quote:after {
  -moz-transform: skewX(50deg);
  -ms-transform: skewX(50deg);
  -webkit-transform: skewX(50deg);
  transform: skewX(50deg);
  content: "";
  position: absolute;
  top: 100%;
  right: 25px;
  border-width: 30px 35px 0 0;
  border-style: solid;
  border-color: #f5f1ed transparent;
}
</style>